import React from "react";
import { TextField } from "@mui/material";

const TimeSelector = (props) => {
    return(
        <TextField
            size="small"
            id="time"
            label={props.label}
            type="time"
            value={props.value !== null ? props.value : ''}
            InputLabelProps={{
                shrink: true,
            }}
            sx={{ width: '100%' }}
            onChange={(newValue) => {
                if (newValue.target.value != '') {
                    newValue.target.classList.add('has-value');
                }
                else {
                    newValue.target.classList.remove('has-value');
                }
                props.onChange(newValue.target.value)
            }
        }
            helperText={props.errorMsg}
            error={props.errorMsg.length > 0 ? true : false}
        />
    )
}

export default TimeSelector;